//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Chart from "chart.js";
import annotation from "chartjs-plugin-annotation";
import "@nuxeo/nuxeo-elements/nuxeo-document.js";
import {BFormInput, BFormTags} from "bootstrap-vue";
import {insightService} from "@/insight-service";
import PublishedModelCard from "../components/cards/PublishedModelCard";
import {mapGetters, mapMutations} from "vuex";
import Missions from "../components/mission/Missions";
import Metrics from "../components/metrics/Metrics";

export default {
  name: "Model",
  components: {
    PublishedModelCard,
    BFormTags,
    BFormInput,
    Missions,
    Metrics,
  },

  data() {
    return {
      loading: true,
      headers: {
        "fetch.document": "versionLabel",
        depth: "children",
        properties: "*",
      },
      versions: [],
      selectedVersions: [],
      publishedVersions: [],
      currentGraph: {},
      currentGraphAllData: {},
      exportStatus: {},
      selectedLabels: [],
      fields: [
        {
          key: 'version',
          label: this.$t('model.summary.table.column.1'),
          thStyle: {
            'width': '8%'
          }
        },
        {
          key: 'version_label',
          label: this.$t('model.summary.table.column.5'),
          thStyle: {
            'width': '25%'
          }
        },
        {
          key: 'date',
          label: this.$t('model.summary.table.column.2'),
          thStyle: {
            'width': '10%'
          }
        },
        {
          key: 'labels',
          label: this.$t('model.summary.table.column.3')
        },
        {
          key: 'published',
          label: this.$t('model.summary.table.column.4'),
          thStyle: {
            'width': '8%'
          }
        }
      ],
    };
  },

  computed: {
    ...mapGetters(["currentModel", "enrichers", "projectId"]),
  },

  mounted() {
    this.loading = true;
    if (this.currentModel && !this.currentModel.isVersion) {
      this.setVersions(this.currentModel);
      this.createChart(this.$refs.cardChartVersions);
      this.createChartAllData(this.$refs.cardChartAllData);
      this.loading = false;
    } else {
      this.$refs.document
          .get()
          .then((result) => {
            this.setCurrentModel(result);
            this.setVersions(result);
            this.createChart(this.$refs.cardChartVersions);
            this.createChartAllData(this.$refs.cardChartAllData);
            this.loading = false;
          })
          .catch((error) => {
            console.error(error);
            this.displayError(error);
            this.loading = false;
          });
    }
  },

  methods: {
    formatDate(date) {
      return insightService.formatDate(date);
    },
    setVersions(model) {
      this.versions = model.contextParameters.versions.entries.filter(
          (version) => version.isVersion
      );
      if (this.currentModel.isVersion) {
        this.versions.push(this.currentModel);
      }
      this.publishedVersions = this.versions.map((version) => {
        if (version.properties["ai_model:deployment_information"][
            "publishing_state"] === "published") {
          return version;
        }
      });
      // Initialize selected checkboxes
      for (let i = 0; i < this.versions.length; i++) {
        this.selectedVersions[i] = i;
      }
    },
    saveLabels(labels, uid) {
      this.$refs.aiAPI.path = `ai/${this.projectId}/model/${uid}/labels`;
      this.$refs.aiAPI.data = labels;
      this.$refs.aiAPI.post()
          .then(() => {
            this.$refs.fireEvent.params = {
              name: 'invalidateModelDefinitions',
            }
            this.$refs.fireEvent.execute();
          }).catch(() => {
        this.displayError(`Cannot update labels`);
      });
    },
    saveVersionLabel(versionLabel, uid) {
      this.$refs.aiAPI.path = `ai/model/${uid}/versionLabel/${versionLabel}`;
      this.$refs.aiAPI.put().catch(() => {
        this.displayError(`Cannot update version label`);
      });
    },
    togglePublish(model) {
      const isPublished = insightService.isPublished(model);
      const op = isPublished ? this.$refs.unpublish : this.$refs.publish;
      op.input = model.uid;
      op.execute()
          .then(() => {
            if (isPublished) {
              model.properties[
                  "ai_model:deployment_information"
                  ].publishing_state = "never_published";
              this.displaySuccess(
                  this.$t("card.active.model.action.unpublish.success")
              );
            } else {
              model.properties[
                  "ai_model:deployment_information"
                  ].publishing_state = "published";
              this.displaySuccess(
                  this.$t("card.active.model.action.publish.success")
              );
            }
            this.$refs.fireEvent.params = {
              'name': 'invalidateModelDefinitions',
            }
            this.$refs.fireEvent.execute();
          })
          .catch((error) => {
            this.displayError(error);
          });
    },
    isPublished(model) {
      return insightService.isPublished(model);
    },
    getLiveModel(model) {
      return insightService.getLiveModel(model);
    },
    isTrained(model) {
      return insightService.isTrained(model);
    },
    isTraining(model) {
      return insightService.isTraining(model);
    },
    selectVersion() {
      this.createChart(this.$refs.cardChartVersions);
    },
    navigateBack() {
      this.$router.back();
    },
    ...mapMutations({
      displaySuccess: "displaySuccess",
      displayError: "displayError",
      setCurrentModel: "setCurrentModel",
    }),
    getRandomRGBA() {
      const o = Math.round,
          r = Math.random,
          s = 255;
      const color =
          "rgba(" + o(r() * s) + "," + o(r() * s) + "," + o(r() * s) + ",";
      const lineColor = color + "1)";
      const bgColor = color + "0.1)";
      return {lineColor, bgColor};
    },
    createChartAllData(chart) {
      if (this.currentGraphAllData &&
          Object.keys(this.currentGraphAllData).length !== 0) {
        this.currentGraphAllData.destroy();
      }
      let allData = [];
      let versions = [];
      let dates = [];
      let disableChart = true;

      const evaluations = this.currentModel.contextParameters.versionEvaluations;

      // Get all related versions
      if (!evaluations) {
        return;
      }

      versions = evaluations["x_version"];

      // fill the dates
      dates = evaluations["x_time"].map((date) => insightService.formatDate(date));

      versions.forEach((version) => {
        const versionResults = evaluations[version];
        if (versionResults && versionResults.length) {
          allData.push((versionResults.map(
                  result => !result ? null : (result * 100).toFixed(2))
          ));
        }
      });

      if (allData.length) {
        disableChart = false;
      }

      let datasets = [];

      allData.forEach((data, index) => {
        const {lineColor, bgColor} = this.getRandomRGBA();
        const dataset = {
          label: versions[index],
          data: data,
          fillOpacity: 0.3,
          borderColor: lineColor,
          backgroundColor: bgColor,
          borderWidth: 2,
          fill: true,
          pointRadius: 2,
        };
        datasets.push(dataset);
      });

      let annotations = {};
      if (disableChart) {
        annotations = {
          annotations: [
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: 50,
              borderColor: "black",
              borderWidth: 0.1,
              label: {
                content: "No evaluations yet",
                enabled: true,
              },
            },
          ],
        };
      }

      this.currentGraphAllData = new Chart(chart, {
        plugins: [annotation],
        maintainAspectRatio: false,
        type: "line",
        data: {
          datasets: datasets,
        },
        options: {
          annotation: annotations,
          responsive: true,
          spanGaps: true,
          maintainAspectRatio: false,
          hover: {
            mode: "index",
          },
          legend: {
            display: true,
            position: "bottom",
          },
          scales: {
            xAxes: [
              {
                display: true,
                type: "category",
                labels: dates,
              },
            ],
            yAxes: [
              {
                display: true,
                scaleLabel: {
                  display: false,
                },
                ticks: {
                  beginAtZero: true,
                  stepSize: 25,
                  max: 100,
                  callback: function (value) {
                    return value + "%";
                  },
                },
              },
            ],
          },
        },
      });
    },
    createChart(chart) {
      if (this.currentGraph && Object.keys(this.currentGraph).length !== 0) {
        this.currentGraph.destroy();
      }

      let allData = [];
      let dates = [];
      let disableChart = true;

      this.selectedVersions.forEach((versionIndex) => {
        let versionDates = [];
        let data = {};
        let version = this.versions[versionIndex];
        const trainingAccuracy = version.properties["ai_model:main_result"];
        
        // xAxes - the training date
        versionDates.push(
            insightService.formatDateWithYear(insightService.getMoment(version.properties["job_sagemaker:end"]))
        );
        // yAxes - all evaluations results
        data[
            insightService.formatDate(version.properties["job_sagemaker:end"])
            ] = (trainingAccuracy * 100).toFixed(2);

        const evaluations = version.contextParameters.evaluations;
        if (evaluations) {
        const evalResults = evaluations.eval_results;
          // x and y Axes - dates and values of evaluations
          if (evalResults && Object.keys(evalResults).length !== 0) {
            disableChart = false;
            evalResults.forEach((result) => {
              versionDates.push(result.time);
              data[insightService.formatDate(result.time)] = (result.accuracy * 100).toFixed(2);
            });
          }
        }

        Array.prototype.push.apply(dates, versionDates);
        allData.push(data);
      });

      // Let's sort chronologically
      dates = dates.sort((date1, date2) => insightService.getMoment(date1) - insightService.getMoment(date2));
      // Let's format the dates and remove all duplicates
      dates = dates
          .map((date) => insightService.formatDate(date))
          .filter((value, index, self) => self.indexOf(value) === index);

      let sortedAllData = [];
      allData.forEach((data) => {
        let dateData = [];
        dates.forEach((date) => {
          dateData.push(data[date] ? data[date] : null);
        });
        sortedAllData.push(dateData);
      });

      let datasets = [];

      sortedAllData.forEach((data, index) => {
        let {lineColor, bgColor} = this.getRandomRGBA();
        let dataset = {
          label: this.versions[index].versionLabel,
          data: data,
          fillOpacity: 0.3,
          borderColor: lineColor,
          backgroundColor: bgColor,
          borderWidth: 2,
          fill: true,
          pointRadius: 2,
        };
        datasets.push(dataset);
      });

      let annotations = {};
      if (disableChart) {
        annotations = {
          annotations: [
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: 0.5,
              borderColor: "black",
              borderWidth: 0.1,
              label: {
                content: "No evaluations yet",
                enabled: true,
              },
            },
          ],
        };
      }

      this.currentGraph = new Chart(chart, {
        plugins: [annotation],
        maintainAspectRatio: false,
        type: "line",
        data: {
          datasets: datasets,
        },
        options: {
          annotation: annotations,
          responsive: true,
          spanGaps: true,
          maintainAspectRatio: false,
          hover: {
            mode: "index",
          },
          legend: {
            display: true,
            position: "bottom",
          },
          scales: {
            xAxes: [
              {
                display: true,
                type: "category",
                labels: dates,
              },
            ],
            yAxes: [
              {
                display: true,
                scaleLabel: {
                  display: false,
                },
                ticks: {
                  beginAtZero: true,
                  stepSize: 25,
                  max: 100,
                  callback: function (value) {
                    return value + "%";
                  },
                },
              },
            ],
          },
        },
      });
    },
  },
};
